import { render } from "./WebCourses.vue?vue&type=template&id=0bc05c8c&scoped=true"
import script from "./WebCourses.vue?vue&type=script&lang=js"
export * from "./WebCourses.vue?vue&type=script&lang=js"

import "./WebCourses.vue?vue&type=style&index=0&id=0bc05c8c&scoped=true&lang=css"
import "./WebCourses.vue?vue&type=style&index=1&id=0bc05c8c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc05c8c"]])

export default __exports__